import IntlMessages from "@richbeauty/utility/IntlMessages";
import { COMMON_FORM_ITEM_RULE } from "shared/constants/AppConst";
import { AppInputType } from "shared/constants/AppEnums";

const useImportCustomerLeadFileFieldConfig = () => {
  return [
    {
      type: AppInputType.FILE_UPLOAD,
      formItemConfig: {
        name: "file",
        label: <IntlMessages id="common.file" />,
        labelCol: 12,
        rules: [COMMON_FORM_ITEM_RULE.REQUIRED],
      },
      inputConfig: {
        multiple: false,
      },
    },
  ];
};

export default useImportCustomerLeadFileFieldConfig;
